<template>
    <div class="notes-and-insights">
        <notes-editor />

        <div class="border-bottom"></div>

        <insights v-if="!isFdaFriendly" :insights="well.insights" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NotesEditor from '../common/NotesEditor'
import Insights from '../common/Insights'

export default {
    name: 'NotesAndInsights',
    components: { NotesEditor, Insights },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        })
    }
}
</script>

<style lang="scss" scoped>
.notes-and-insights {
    display: flex;
    flex-direction: column;

    .insights {
        flex-grow: 1;
    }

    @media screen and #{$new-break4close} {
        .border-bottom {
            display: none;
        }
    }
}
</style>
